import readXlsxFile from 'read-excel-file';

export default async (file) => {
    const jsonData = [];
    try {
        const rows =  await readXlsxFile(file);
        const headerArr = rows[0];
        const bodyArr = rows.slice(1, rows.length);
        let obj;
        bodyArr.forEach(function(rowValues){
            obj = {};
            headerArr.forEach(function(attr, index){
                const attribute = attr.toLowerCase();
                obj[attribute.replace(/\W+/g, ' ').split(/ |\B(?=[A-Z])/).map(word => word).join('_')] = rowValues[index];
            });
            jsonData.push(obj);
        });
    } catch (e) {
        console.log(e);
    }
    return jsonData;
};
